export default __webpack_public_path__ + "static/media/20210501_105845-min.499fad27.jpg";